import request from "../request";

export const cancel = ({orderId, code}) => {
	return request({
		url: "/promo/cancel",
		data: {
			order_id: orderId,
			code,
		},
	});
};

export const apply = ({orderId, code}) => {
	return request({
		url: "/promo/apply",
		data: {
			order_id: orderId,
			code,
		},
	});
};
